import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme from '../../../styles/theme';

const FadeInOut = ({
  children, visible, absolute, classes,
}) => (
  <div className={cn(classes.fade, {
    [classes.absolute]: absolute,
    [classes.visible]: visible,
    [classes.hidden]: !visible,
  })}
  >
    {children}
  </div>
);

FadeInOut.defaultProps = {
  absolute: false,
};

FadeInOut.propTypes = {
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool.isRequired,
  absolute: PropTypes.bool,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default compose(
  injectSheet({
    fade: {
      transition: 'opacity 0.3s ease',
    },
    absolute: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      alignItems: 'center',
    },
    visible: {
      opacity: 1,
    },
    hidden: {
      overflow: 'hidden',
      pointerEvents: 'none',
      opacity: 0,
      [theme.breakpoints.down('md')]: {
        maxHeight: '300px',
      },
    },
  }),
)(FadeInOut);
